/* eslint-disable prefer-destructuring */
export function handleErrorResponse(response) {
  const transformed = {};

  const { errorObj } = response.error;
  const { data, statusCode, message } = errorObj || {};
  transformed.statusCode = statusCode;

  if (data && data.error) {
    const { error } = data;
    if (Array.isArray(error.message)) {
      transformed.message = error.message[0];
      return transformed;
    }
  }
  transformed.message = message || 'Unknown error';

  return transformed;
}
